export const SUBSCRIBERS_EXPORT_LIST_PATH = "/sx";
export const SUBSCRIBERS_EXPORT_CREATE_VIEW_PATH = "/sx/create";
